// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext, useState} from 'react';
// @ts-ignore
import {format_price} from '/util/country.js';
// @ts-ignore
import {get_price_plan, parse_period}
    from '../../../../svc/account/pub/membership.js';
// @ts-ignore
import {Tooltip} from '/www/hola/pub/lib/tooltip.js';
import styles from './plans_select.module.less';
import Icon_chevron_down from '../img/svg/icon/chevron_down.svg';
import {Svg} from '../ui/svg';
import cn from 'classnames';
import {Settings_context} from '../settings_ctx';
import {Radio} from '../lib/radio';
import {i_plan_extended} from './plus_types';

interface i_plans_select_props {
    plans: i_plan_extended[];
    plan: i_plan_extended;
    currency: string;
    on_change: (plan: any)=>void;
}

export const Plans_select = (props: i_plans_select_props)=>{
    const {theme} = useContext(Settings_context);
    const [is_plans_select_hovered, set_is_plans_select_hovered]
        = useState(false);
    const price_o = get_price_plan(props.plan, props.currency);
    const tooltip_ref = {close: ()=>{
        // XXX dmitriiz: redefined from tooltip.js
    }};
    let {short_name, free_period, every} = props.plan;
    const {count: free_period_count} = parse_period(free_period)||{};
    let {month_price, price} = price_o;
    const handle_mouse_enter = ()=>set_is_plans_select_hovered(true);
    const handle_mouse_leave = ()=>set_is_plans_select_hovered(false);
    return <Tooltip click_mode cls_cn={styles.popup_position}
      prop_ref={tooltip_ref}
      content={<div className={styles.list_of_plans}
        onMouseEnter={handle_mouse_enter}
        onMouseLeave={handle_mouse_leave}>
        {props.plans.map(pl=>{
          const price_obj = get_price_plan(pl, props.currency);
          const selected = pl.id==props.plan.id;
          const {count} = parse_period(pl.free_period)||{};
          const special_plan_info = count || pl.renewal_price
            ? <span className={cn(theme.primary)}>
              {count ? `1+${count}` : 'Welcome'}</span> : null;
          return <div key={pl.id}
            onClick={()=>{
              props.on_change(pl);
              tooltip_ref.close();
            }}
            className={cn(styles.row_plan, selected
              && !is_plans_select_hovered && styles.selected)}>
            <Radio on_change={()=>{
              props.on_change(pl);
              tooltip_ref.close();
            }} value={pl.id} checked={selected} label={''}/>
            <div className={styles.title_and_price}>
              <p className={cn(styles.title, theme.bold,
                theme.logo_grey)}>{special_plan_info}{pl.short_name} Plan</p>
              <div className={styles.price}>
                <p className={cn(theme.bold, theme.logo_grey)}>
                  {format_price(props.currency,
                    price_obj.month_price||price_obj.price)}</p>
                <p className={cn(theme.p2)}>&nbsp;/{' '}
                  {price_obj.month_price ? 'month' : pl.every}</p>
              </div>
            </div>
          </div>;
        })}
      </div>}>
      <div className={styles.plans_title}>
        <div className={styles.plans_row}>
          <h5 className={cn(styles.plan_name, theme.bold,
            theme.logo_grey)}>{short_name} Plan</h5>
          <h5 className={cn(theme.bold, theme.logo_grey)}>
            {format_price(props.currency, month_price||price)} </h5>
          <p className={cn(theme.logo_grey)}>
            &nbsp;/ {month_price ? 'month' : every}</p>
          <Svg icon={<Icon_chevron_down width={24} height={24}/>}/>
        </div>
        <div className={styles.plans_row}>
          <p className={cn(theme.p2, theme.grey_2)}>
            {free_period?.endsWith(' M')
              ? `Only ${format_price(
                props.currency, price)} for the first `
                +`${1+free_period_count} ${every}s`
              : `Billed as one payment of ${format_price(
                props.currency, price)}`}
          </p>
        </div>
      </div>
    </Tooltip>;
};
